<template>
  <div class="ereport">
    <div class="point">
      <div>督查点位：</div>
      <div class="name">{{ point }}</div>
    </div>
    <div class="content">
      <div>考察内容：</div>
      <div>{{ title }}</div>
    </div>
    <div class="work" v-if="departList.length > 0">
      <div>归属单位：</div>
      <div class="area-list">
        <div v-for="(item, i) in departList" :key="i">
          {{ item.name }}
        </div>
      </div>
    </div>
    <div class="h"></div>
    <div class="address">
      <div><span class="red">*</span>地址</div>
      <div>
        <input type="text" placeholder="请输入地址" v-model="address" />
      </div>
    </div>
    <div class="imgcon">
      <div>
        <span class="red">*</span>上传照片
        <span class="tips">（现场拍照、最多3张）</span>
      </div>
      <div>
        <upload :maxCount="3" v-model="imgList" />
      </div>
    </div>
    <div class="describe">
      <div class="title">事件描述</div>
      <div>
        <textarea
          placeholder="请简单描述..."
          v-model="content"
          @input="getAreaNum"
        ></textarea>
      </div>
    </div>
    <div class="btn">
      <div @click="saveOrder" v-if="can_click">存档</div>
      <div class="no-use" v-else>存档</div>
      <div @click="toSendPage">派单</div>
    </div>
  </div>
</template>
<script>
// import wx from 'wx'
// import qq from 'qq'
import { mapActions, mapGetters } from "vuex";
import { postEvent } from "./api";
import upload from "@/components/Upload";
import axios from "axios";
export default {
  components: {
    upload,
  },
  data() {
    return {
      cate: 0,
      point_id: "",
      point: "",
      title: "",
      address: "",
      imgList: "",
      content: "",
      lat: "",
      lng: "",
      can_click: true,
    };
  },
  computed: {
    ...mapGetters({
      cateGet: "cate/get",
    }),
    pointData() {
      return this.cateGet("point");
    },
    form() {
      return this.cateGet("form");
    },
    cateContent() {
      return this.cateGet("cateContent");
    },
    departList() {
      return this.cateGet("departList");
    },
  },
  watch: {
    cateContent: {
      immediate: true,
      handler(v) {
        this.title = v;
      },
    },
    form: {
      immediate: true,
      handler(v) {
        this.cate = v.cate;
        this.address = v.address;
        this.imgList = v.img;
        this.content = v.content;
      },
    },
    pointData: {
      immediate: true,
      deep: true,
      handler() {
        const { id, title } = this.pointData;
        this.point_id = id;
        this.point = title;
        document.title = title;
      },
    },
  },
  created() {
    this.initChooseMap();
  },
  methods: {
    ...mapActions({
      setReport: "cate/setReport",
      clear: "cate/clear",
    }),

    getAreaNum() {
      this.valueNum = this.content.length;
    },
    // 初始化地图
    initChooseMap() {
      // wx.ready(() => {
      //   this.getAddress();
      // });
      this.getLocation();
    },
    getLocation() {
      let _this = this;
      let geolocation = new qq.maps.Geolocation(
        "OSABZ-ULPWP-RE5DY-V3GID-U4TJ2-DVBQZ",
        "myapp2"
      );
      geolocation.getLocation(showPosition, showErr, { timeout: 8000 });
      function showPosition(position) {
        console.log("showPosition", position);
        _this.lat = position.lat;
        _this.lng = position.lng;
        _this.address = position.province + position.city + position.addr;
      }
      function showErr() {
        console.log("定位失败！");
        // _this.getLocation()
      }
    },
    // 获取地理位置
    getAddress() {
      console.log("调用了");
      wx.getLocation({
        type: "wgs84", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success: (res) => {
          this.lat = res.latitude;
          this.lng = res.longitude;
          // 腾讯地图坐标换地址
          var geocoder = new TMap.service.Geocoder();
          var location = new TMap.LatLng(
            Number(res.latitude),
            Number(res.longitude)
          );
          geocoder
            .getAddress({ location: location }) // 将给定的坐标位置转换为地址
            .then((result) => {
              this.address = result.result.address;
              // 显示搜索到的地址
            });
          // 百度地图坐标换地址
          // var point = new Bmap.Point(res.longitude, res.latitude);
          // // var point = new Bmap.Point(116.331398, 39.897445)
          // var geoc = new Bmap.Geocoder();
          // geoc.getLocation(point, (rs) => {
          //   console.log("rs", rs);
          //   this.address = rs.address;
          //   // alert(rs.address)
          // });
        },
        fail: (fail) => {
          console.log(fail);
        },
        error: (err) => {
          console.log(err);
        },
      });
    },
    // 跳转派单
    toSendPage() {
      if (!this.address) {
        this.$toast.fail("请输入地址");
      } else if (!this.imgList) {
        this.$toast.fail("请上传最少一张照片");
      } else {
        this.setReport({
          address: this.address,
          img: this.imgList,
          content: this.content,
        });
        this.$router.push({
          name: "sendOrder",
          query: {},
        });
      }
    },
    // 存档
    saveOrder() {
      if (!this.address) {
        this.$toast.fail("请确认地址");
      } else if (!this.imgList) {
        this.$toast.fail("请上传最少一张照片");
      } else {
        this.can_click = false;
        let params = {
          cate: this.form.cate,
          address: this.address,
          img: this.imgList,
          content: this.content,
          is_archive: 1,
          token: window.localStorage.getItem("token"),
        };
        // console.log("参数", params);
        postEvent(params).then((res) => {
          console.log("res", res);
          if (res.code == 0) {
            this.$toast.success("存档成功!");
            this.clear();
            setTimeout(() => {
              this.$router.replace("/");
            }, 1200);
          } else {
            this.$toast.fail(res.message);
          }
        });
      }
    },
  },
};
</script>

<style scoped lang="less">
.ereport {
  color: #333;
  font-size: 15px;
  text-align: left;
  background: #fff;
  padding: 0 0 10px;
  > div {
    width: calc(100% - 30px);
    margin: auto;
    .red {
      color: #ff0000;
    }
    .tips {
      color: #9c9c9c;
      font-size: 14px;
    }
  }
  .point {
    border-bottom: 1px solid #d7d7d7;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 11px;
    padding: 11px 0;
  }
  .content {
    > div:first-child {
      line-height: 20px;
      margin-bottom: 10px;
    }
    > div:last-child {
      padding: 11px;
      background: rgba(244, 246, 248, 1);
      border-radius: 6px;
      margin-bottom: 10px;
    }
  }
  .work {
    > div:first-child {
      line-height: 20px;
      margin-bottom: 10px;
    }
    .area-list {
      display: flex;
      flex-wrap: wrap;
      > div {
        margin-right: 15px;
        height: 34px;
        padding: 0 15px;
        line-height: 34px;
        font-size: 12px;
        color: #999999;
        background: rgba(238, 242, 241, 1);
        text-align: center;
        margin-bottom: 10px;
        border-radius: 2px;
      }
    }
  }
  .h {
    width: 100%;
    height: 10px;
    background: rgba(243, 244, 246, 1);
    margin-bottom: 10px;
  }
  .address {
    border-bottom: 1px solid #d7d7d7;
    margin-bottom: 11px;
    > div:last-child {
      margin: 11px 0;
      input {
        height: 40px;
        width: 100%;
        border: none;
        background: rgba(244, 246, 248, 1);
        padding-left: 10px;
      }
    }
  }
  .imgcon {
    border-bottom: 1px solid #d7d7d7;
    margin-bottom: 11px;
    > div:last-child {
      margin: 14px 0 10px 0;
    }
  }
  .describe {
    margin-bottom: 10px;
    .title {
      margin: 5px auto;
    }
    textarea {
      width: 100%;
      height: 2.8rem;
      border: 0.02rem solid rgba(225, 225, 225, 1);
      border-radius: 6px;
      padding: 10px;
      background: rgba(244, 246, 248, 1);
    }
    textarea::-webkit-input-placeholder {
      color: #969799;
    }
  }
  .btn {
    display: flex;
    justify-content: space-between;
    margin-bottom: 30px;
    div {
      height: 1rem;
      width: 3.34rem;
      text-align: center;
      line-height: 1rem;
    }
    > div:first-child {
      border: 1px solid #206aff;
      color: #206aff;
    }
    > div:last-child {
      background: rgba(32, 106, 255, 1);
      color: #ffffff;
    }
    .no-use {
      background-color: rgba(153, 153, 153, 0.5) !important;
      color: #fff !important;
      border: 1px solid #fff !important;
    }
  }
}
</style>
